<div class="detalle-devolucion-masiva">
      <app-card Theme="card-primary shadow background-white">
        <div card-content>
          <app-head Theme="head-normal">
            <div head-content class="inline-ico-text">
              <div class="head">
                <app-text Theme="BodyBold" [Text]="'Descarga de cartola de movimientos, periodos a definir.'" [RadiusLoading]="10" style="color: #0078c8;"></app-text>
              </div>
              <div class="body">
                <div class="imagen-restitucion">
                  <img src="./assets/img/life_style_working_01.jpg" />
               </div>
               <br/>
               <button tabindex="3" class="btn-submit" type="submit" (click)="downloadCartola()">Descargar</button>
              </div>
            </div>
          </app-head>
        </div>
      </app-card>
  </div>